import { string } from "prop-types"
import React from "react"

export default function PricingRowHT({ amount }) {
  return (
    <td>
      <p>{amount}</p>
    </td>
  )
}

PricingRowHT.propTypes = {
  amount: string
}
